import cloneDeep from 'lodash/cloneDeep';
import { mapState } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'NiotaClassicDevicesEditDeviceForm',
  props: {
    editedItem: {
      type: Object,
      required: false,
      default: () => ({})
    },
    formSaving: {
      type: Boolean,
      required: false,
      default: false
    },
    showStatics: {
      type: Boolean,
      required: false,
      default: false
    },
    deviceTypes: {
      type: Array,
      required: false,
      default: new Array()
    },
    showDeviceType: {
      type: Boolean,
      required: false,
      default: false
    },
    isIotHubManager: {
      type: Boolean,
      required: false,
      default: false
    },
    adrLimits: {
      type: Array,
      required: false,
      default: new Array()
    }
  },
  data: function () {
    return {
      formItem: null,
      operationalStatus: [{
        value: 0,
        text: this.$i18n_t('NiotaClassic.Devices.form.unset')
      }, {
        value: 1,
        text: this.$i18n_t('NiotaClassic.Devices.form.inTransit')
      }, {
        value: 2,
        text: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation')
      }, {
        value: 3,
        text: this.$i18n_t('NiotaClassic.Devices.form.inOperation')
      }, {
        value: 4,
        text: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive')
      }, {
        value: 5,
        text: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      }],
      timeUnits: [{
        value: 'h',
        text: this.$i18n_t('NiotaClassic.Devices.form.hour')
      }, {
        value: 'd',
        text: this.$i18n_t('NiotaClassic.Devices.form.day')
      }, {
        value: 'w',
        text: this.$i18n_t('NiotaClassic.Devices.form.week')
      }, {
        value: 'm',
        text: this.$i18n_t('NiotaClassic.Devices.form.month')
      }],
      booleanBattery: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    disableField() {
      if (!get(this.formItem, 'deviceType.properties.battery_level') || !get(this.formItem, 'deviceType.properties.battery_type') && !this.booleanBattery) {
        return true;
      }
      return false;
    }
  },
  watch: {
    editedItem() {
      this.initData();
    }
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.formItem = cloneDeep(this.editedItem);
      if (!this.formItem.properties) {
        this.formItem['properties'] = {};
      }
      if (!get(this.formItem, 'properties.critical_time_without_package_level')) {
        this.formItem.properties['critical_time_without_package_level'] = {
          time: null,
          unit: {
            text: null,
            value: null
          }
        };
      }
      let batteryType = get(this.formItem, 'deviceType.properties.battery_type');
      if (batteryType === 'Boolean') {
        this.booleanBattery = true;
      }
    },
    filterItems(item, queryText) {
      return item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    updateData(item, value) {
      // make sure to truly reset the value if it was un-selected here, otherwise the API will just keep the current value
      this.$emit('updateData', item, value === undefined ? null : value);
    }
  }
};